export const Value = `
fragment Value on scalarValue {
  booleanValue dateValue stringValue numberValue
}`

export const TreeMapValues = `
${Value}
fragment TreeMapValues on scalarValue {
  ...Value
  arrayValue {
    ...Value
    objectValue {
      key value { ...Value }
    }
  }
  objectValue {
    key value { ...Value }
  }
}`

export const Benefit = `
${TreeMapValues}
fragment Benefit on benefit {
  currencyCode description name typeId
  formattedValue: value
  value: value2 {
    ...TreeMapValues
  }
}`

export const BenefitClaim = `
${Benefit}
fragment BenefitClaim on benefitClaim {
  benefit {
    ...Benefit
  }
  currencyCode
  benefitDescription
  benefitName
  id
  values{
    approvedAmount
    approvedCurrency
    billedAmount
    billedCurrency
    unit
  }
  totalValues{
    approvedAmount
    approvedCurrency
    billedAmount
    billedCurrency
    unit
  }
  value {
    ...TreeMapValues
  }
}`

const Note = `
fragment Note on note {
  content
  createdAt lastModifiedAt
  # createdBy lastModifiedBy
  id
  title
}`

export const Claim = `
fragment Claim on claim {
  claimant {
    id name
  }
  policy {
    id status issuerNumber
  }
  createdAt
  id
  issuerNumber
  status
}`

export const DetailedClaim = `
${Note}
fragment DetailedClaim on claim {
  issuerNumber
  facts{
    id
    type
    value{
      stringValue
      numberValue
      booleanValue
      dateValue
    }
  }
  totalValues{
    approvedAmount
    approvedCurrency
    billedAmount
    billedCurrency
    unit
  }
  claimant {
    id name
    notes {
      ...Note
    }
  }
  policy{
    id
    issuerNumber
    acceptedOffer{
      product{
        productId{
          type
          plan
          version
        }
      }
    }
  }
  createdAt
  id status
  rejectionCodes {
    code
    name
  }
  rejectionRemarks
  diagnosisCodes{
    code
    name
    description
  }
  operationCodes{
    code
    name
    description
  }
  provider{
    id
    name
    internalCode
  }
  notes{
    ...Note
  }
}`

export const DetailedPolicy = `
${Benefit}
${Note}
fragment DetailedPolicy on policy {
  id
  notes {
    ...Note
  }
  claimBalance{
    ...Benefit
  }
  acceptedOffer{
    product {
      benefits {
        ...Benefit
      }
      pricing {
        currencyCode
      }
    }
  }
}`
